import React, { useMemo } from 'react';
import { bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card } from '@cards/Card';
import DetailForm from '@components/DetailForm';
import DetailRow from '@components/DetailRow';
import useWizard from '@components/Wizard/useWizard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import LanguageIcon from '@components/LanguageIcon';

function ReviewOrganisationDetails({ editing }) {
  const { t } = useTranslation();
  const { formData } = useWizard();

  // hacky fix for hospital name changing to previous unedited name.
  // Wizard initialData prop isn't just initial anymore and there are some issues with it overriding things that have been edited.
  const hospitalName = useMemo(() => formData.details.hospitalName, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card className="hospital-wizard-card" title={t('organisations:Wizard.details.titles.details')}>
      <DetailForm>
        <DetailRow label={t('organisations:Wizard.details.labels.name')} value={hospitalName} />
        <DetailRow
          label={t('cards:PatientDetails.labels.language')}
          value={<LanguageIcon showText language={formData.details.language} />}
        />
      </DetailForm>
      {/* {editing ? null : (
        <>
          <h3>{t('organisations:Wizard.details.titles.admin')}</h3>
          <DetailForm>
            <DetailRow
              label={t('organisations:Wizard.details.labels.firstName')}
              value={formData.details.firstName}
            />
            <DetailRow
              label={t('organisations:Wizard.details.labels.lastName')}
              value={formData.details.lastName}
            />
            <DetailRow
              label={t('organisations:Wizard.details.labels.email')}
              value={formData.details.email}
            />
          </DetailForm>
        </>
      )} */}
      <p>
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;
        <em>{t('organisations:Wizard.createTimeInfo')}</em>
      </p>
    </Card>
  );
}

ReviewOrganisationDetails.propTypes = {
  editing: bool,
};

ReviewOrganisationDetails.defaultProps = {
  editing: false,
};

export default ReviewOrganisationDetails;
